import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class ProfileService extends ServiceCRUD {
  constructor() {
    super(`/api/profiles`);
  }
}

export default new ProfileService();
